import React from 'react';
import Loader from '../components/loader';
import HeroHeader from '../components/HeroHeader';
import EnquiryPage from '../components/EnquityPage';
import MetaTags from '../common-components/MetaTags';

class EnquiryFormPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    // document.title = "Student Registration - Learn Quran Easily";
    // document.description = "Learn Quran Easily"
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000); // Simulate a 3-second loading delay
  }


  render() {
    const breadcrumbs = [
        { label: 'Home', href: '#', isCurrentPage: false },
        { label: 'Pages', href: '#', isCurrentPage: false },
        { label: 'Student-Registration', href: '#', isCurrentPage: true },
      ];

    return <>
     <MetaTags
        title="Student Registration - Learn Quran Easily"
        description="Register now to start your journey of learning the Quran online with expert Islamic teachers. Simple and quick student registration at Learn Quran Easily."
        keywords="Student Registration, Enroll Quran Course, Online Quran Classes, Join LQE, Register for Islamic Education"
        author="Learn Quran Easily Team"
        url="https://learnquraneasily.in/student-registration"
        image="https://lqe-assets.learnquraneasily.in/1747284949484_Lqe_logo.png"
    />
      {this.state.loading ? <Loader /> :
        <>
          <HeroHeader  title="Student Registration" breadcrumbs={breadcrumbs} />
          <EnquiryPage />
        </>}
    </>
  }
}

export default EnquiryFormPage;
